// extracted by mini-css-extract-plugin
export default {"formulaField":"Formula_formulaField__5zxFe"};